"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Modal (a.k.a. "Dialog") informs users about a task and can contain critical information or require decisions.
 *
 * Modals typically appear above the page in elevation, darkening the area behind it to call focus to content within the modal.
 */
const Modal = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({
    "aria-labelledby": "modalDialogWindow",
    "aria-label": "modal"
  }, props), children);
};

// Sub-components (Header, Body, Footer)
const ModalHeader = _ref2 => {
  let {
    loading,
    title,
    onClose,
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Modal.default.Header, props, !loading && /*#__PURE__*/_react.default.createElement("h2", {
    className: "modal-title",
    id: "modalDialogWindow"
  }, title), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "close",
    onClick: () => onClose(),
    "aria-label": "close modal dialog",
    "data-dismiss": "modal"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true"
  }, "X")));
};
exports.ModalHeader = ModalHeader;
ModalHeader.displayName = 'Modal.Header';
ModalHeader.propTypes = {
  loading: _propTypes.default.bool,
  onClose: _propTypes.default.func.isRequired,
  title: _propTypes.default.string
};
ModalHeader.defaultProps = {
  loading: false,
  title: ''
};
const ModalBody = _ref3 => {
  let {
    children,
    loading,
    ...props
  } = _ref3;
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_Modal.default.Body, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-dots-loading-xl--center-modal"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "sr-only"
    }, "Loading Modal")));
  } else {
    return /*#__PURE__*/_react.default.createElement(_Modal.default.Body, props, children);
  }
};
exports.ModalBody = ModalBody;
ModalBody.displayName = 'Modal.Body';
ModalBody.propTypes = {
  children: _propTypes.default.node,
  loading: _propTypes.default.bool
};
ModalBody.defaultProps = {
  loading: false
};
const ModalFooter = _ref4 => {
  let {
    children,
    loading,
    ...props
  } = _ref4;
  if (loading) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, props, children);
  }
};
exports.ModalFooter = ModalFooter;
ModalFooter.displayName = 'Modal.Footer';
ModalFooter.propTypes = {
  children: _propTypes.default.node,
  loading: _propTypes.default.bool
};
ModalFooter.defaultProps = {
  loading: false
};

// Converts sub-components to become properties of the default 'Modal' component.
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

// Modal Props
Modal.propTypes = {
  /** This specifies if you want the dark backdrop to appear, not appear, or appear and be 'static', where clicking on the backdrop will not hide modal. */
  backdrop: _propTypes.default.oneOf(['static', true, false]),
  /** Vertically center the dialog in the window. */
  centered: _propTypes.default.bool,
  /** The content of the Modal. */
  children: _propTypes.default.node.isRequired,
  /** Center or left align the modal header and footer content (only applies to Consumer Theme). Supports Blueprint v3+ */
  contentClassName: _propTypes.default.oneOf(['align', 'default']),
  /** A handler to invoke when the component no longer is visible. */
  onHide: _propTypes.default.func,
  /** The show property displays the modal when true, and hides it when false.  This property can be set by another component (like a button).  */
  show: _propTypes.default.bool,
  /** Renders a large, extra large or small modal. When not provided. */
  size: _propTypes.default.oneOf(['sm', 'md', 'lg', 'xl'])
};

// Modal Default properties
Modal.defaultProps = {
  centered: false,
  contentClassName: 'default',
  backdrop: 'static',
  size: 'md',
  show: true
};

// Exports the default Modal component
var _default = exports.default = Modal;